import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { some, unwrap, map, defaultArg, value as value_65, bind, orElse } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { append, tryHead, tryFind } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { API_Orders_With } from "../Shared/Urls.js";
import { createObj, uncurry2, int32ToString } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { toString } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { Order_$reflection } from "../Shared/ApiDataTypes.js";
import { obj_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { toString as toString_1 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Button, DialogActions, DialogContent, Typography, DialogTitle, Dialog } from "@mui/material";
import { printf, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Company_selection } from "../ViewHelpers.js";
import { Orders_VismaSearchButton } from "./VismaSearchButton.js";
import { filterBox } from "./Orders.js";
import { Orders_Table_Z528D9251 } from "./Table.js";

export function Orders_SelectionModal(orders_SelectionModalInputProps) {
    let elements_3, elements, elems, arg_1, disabled, companyId, elements_1, elems_3, elems_2, elems_4, elements_2;
    const onClose = orders_SelectionModalInputProps.onClose;
    const customerId = orders_SelectionModalInputProps.customerId;
    const companies = orders_SelectionModalInputProps.companies;
    const selectedOpt = orders_SelectionModalInputProps.selectedOpt;
    const isOpen = orders_SelectionModalInputProps.isOpen;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(selectedOpt);
    const originalSelected = patternInput[0];
    const patternInput_1 = reactApi.useState(selectedOpt);
    const setSelected = patternInput_1[1];
    const selected = patternInput_1[0];
    const patternInput_2 = reactApi.useState(false);
    const setLoading = patternInput_2[1];
    const patternInput_3 = reactApi.useState([]);
    const setOrders = patternInput_3[1];
    const orders = patternInput_3[0];
    const patternInput_4 = reactApi.useState(false);
    const anyStatus = patternInput_4[0];
    let patternInput_5;
    const initial_5 = selectedOpt != null;
    patternInput_5 = reactApi.useState(initial_5);
    const withTickets = patternInput_5[0];
    let patternInput_6;
    const initial_6 = orElse(bind((order) => tryFind((dep) => (dep.Id === order.Company.Id), companies), selectedOpt), (companies.length === 1) ? tryHead(companies) : undefined);
    patternInput_6 = reactApi.useState(initial_6);
    const depOpt = patternInput_6[0];
    useEffectWithDeps(() => {
        let properties_2;
        if (depOpt != null) {
            setLoading(true);
            const url = API_Orders_With([["company", int32ToString(value_65(depOpt).Id)], ["customer", int32ToString(customerId)], ["with-ticket", toString(withTickets)], ["any-status", toString(anyStatus)]]);
            let pr_2;
            let pr_1;
            const decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Order_$reflection()), undefined, undefined);
            const data_1 = undefined;
            const caseStrategy_2 = undefined;
            const extra_2 = extraCoders;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString_1(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Order_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
            }
            catch (exn) {
                pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
            pr_2 = (pr_1.then((result_1) => Result_MapError(testRedirect, result_1)));
            pr_2.then((res) => {
                setLoading(false);
                if (res.tag === 0) {
                    setOrders(res.fields[0]);
                }
                else {
                    console.error(some("Could not fetch orders:"), res.fields[0]);
                }
            });
        }
        return createDisposable(() => {
            setOrders([]);
        });
    }, [depOpt, anyStatus, withTickets]);
    const dependencies_1 = [isOpen];
    reactApi.useEffect(() => {
        if (isOpen) {
            patternInput[1](selectedOpt);
            setSelected(selectedOpt);
        }
    }, dependencies_1);
    return MuiHelpers_createElement(Dialog, [["maxWidth", "md"], ["fullWidth", true], ["open", isOpen], ["onClose", (delegateArg, delegateArg_1) => {
        if (delegateArg_1 === "backdropClick") {
        }
        onClose(originalSelected);
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        columnGap: 20 + "px",
    }], (elements = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        columnGap: 20 + "px",
        flexGrow: 1,
    }], (elems = [MuiHelpers_createElement(Typography, [["variant", "h6"], ["style", {
        flexGrow: 0,
    }], ["children", (arg_1 = ctx.Locale.t("Orders.ChooseFromCompany"), toText(printf("%s:"))(arg_1))]]), Company_selection(ctx.Locale, false, depOpt, companies, patternInput_6[1])], ["children", reactApi.Children.toArray(Array.from(elems))])]))), (disabled = (depOpt == null), (companyId = (((depOpt == null) ? -1 : depOpt.Id) | 0), createElement(Orders_VismaSearchButton, {
        disabled: disabled,
        white: false,
        companyId: companyId,
        customerId: customerId,
        callback: (orderOpt_1) => {
            console.debug("Got visma tickes search result", orderOpt_1);
            const orderOpt = orderOpt_1;
            if (orderOpt != null) {
                setOrders(append(orders, [value_65(orderOpt)]));
            }
        },
    })))], ["children", reactApi.Children.toArray(Array.from(elements))])]), MuiHelpers_createElement(DialogContent, [["style", {
        minWidth: 705 + "px",
    }], (elements_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        columnGap: 20 + "px",
    }], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        flexGrow: 1,
    }], (elems_2 = [filterBox(ctx.Locale.t("Orders.WithTicket"), withTickets, (isChecked) => {
        patternInput_5[1](isChecked);
    }), filterBox(ctx.Locale.t("Orders.IncludeClosed"), anyStatus, (isChecked_1) => {
        patternInput_4[1](isChecked_1);
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        minHeight: (3 * 5) + "rem",
    }], (elems_4 = [createElement(Orders_Table_Z528D9251, {
        selectedOpt: unwrap(selected),
        ordersOpt: unwrap(patternInput_2[0] ? undefined : orders),
        onClick: (newSelected) => {
            setSelected(newSelected);
        },
        rowsPerPage: 10,
        withTicketsOpt: withTickets,
        anyStatusOpt: anyStatus,
        rowsPerPageOptionsOpt: new Int32Array([5, 10]),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elements_1))])]), MuiHelpers_createElement(DialogActions, [(elements_2 = [MuiHelpers_createElement(Button, [["variant", "outlined"], ["onClick", (_arg_3) => {
        onClose(originalSelected);
    }], ["children", ctx.Locale.t("Cancel")]]), MuiHelpers_createElement(Button, [["variant", "contained"], ["color", "primary"], ["onClick", (_arg_4) => {
        onClose(selected);
    }], ["children", ctx.Locale.t("Choose")]])], ["children", reactApi.Children.toArray(Array.from(elements_2))])])], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

